import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { CustomTooltipDirective } from 'src/app/shared/directives/custom-tooltip.directive';

@Component({
  selector: 'app-loan-eligibility-financial-info',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxMaskDirective, TranslocoDirective, TranslocoPipe, CustomTooltipDirective],
  templateUrl: './loan-eligibility-financial-info.component.html',
  styleUrl: './loan-eligibility-financial-info.component.css',
  providers: [provideNgxMask()]
})
export class LoanEligibilityFinancialInfoComponent {
  @Input() form!: FormGroup;

  protected thousandSeparator: string = '.';
}
